import { render } from "./company-table.vue?vue&type=template&id=3efc94e1"
import script from "./company-table.vue?vue&type=script&lang=js"
export * from "./company-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__